import { FormProvider } from 'forms';
import React from 'react';
import { CreateClaimInitialState } from './constant';
import { CreateClaimModal } from './CreateClaimModal';

export const CreateFlexiBenefitClaim = () => {
  return (
    <FormProvider initialState={CreateClaimInitialState}>
      <CreateClaimModal />
    </FormProvider>
  );
};
